/** Native provider cards expose only supported server-owned actions. */
import type { StoreProjectSource } from '@testfeed/integration-contracts'
import { shopifyComponentCopy } from '@testfeed/product-language'
import type { IntegrationProviderSummary } from './integration-page-model'
const copy = shopifyComponentCopy.integrationsPage
export function IntegrationProviderCard(props: {
  provider: IntegrationProviderSummary
  sources: StoreProjectSource[]
  voted: boolean
  voteAvailable: boolean
  votePending: boolean
  onVote: () => void
  onChooseProperty?: () => void
  onConnectGoogle?: () => void
  googleSetupUnavailable?: boolean
  onDetails?: (source: StoreProjectSource) => void
}) {
  const soon = props.provider.availability === 'coming_soon'
  const search = props.provider.id === 'google-search-console'
  let label: string = copy.notConnected
  let tone: 'success' | 'warning' | undefined
  if (props.provider.connection?.status === 'active') {
    label = copy.connected
    tone = 'success'
  } else if (props.provider.connection) {
    label = copy.needsAttention
    tone = 'warning'
  }
  if (search) {
    label = copy.notLinked
    if (props.sources.length) {
      label = copy.linked
      tone = 'success'
    }
    if (props.sources.some((row) => !row.connectionAvailable)) {
      label = copy.needsAttention
      tone = 'warning'
    }
  }
  if (soon) {
    label = copy.comingSoon
    tone = undefined
  }
  let vote = null
  if ((soon || props.voted) && props.voteAvailable) {
    let voteLabel: string = copy.vote
    if (props.voted) voteLabel = copy.undoVote
    vote = (
      <s-stack direction="inline" gap="base">
        <s-button disabled={props.votePending} loading={props.votePending} onClick={props.onVote}>
          {voteLabel}
        </s-button>
      </s-stack>
    )
  }
  let actions = null
  if (search && !soon) {
    let choose = null
    let connect = null
    if (props.onChooseProperty) choose = <s-button onClick={props.onChooseProperty}>{copy.useExisting}</s-button>
    if (props.onConnectGoogle) connect = <s-button onClick={props.onConnectGoogle}>{copy.connectGoogle}</s-button>
    actions = (
      <s-stack direction="inline" gap="base">
        {choose}
        {connect}
      </s-stack>
    )
  }
  let unavailable = null
  if ((soon && !props.voteAvailable) || (search && !soon && !props.onChooseProperty && !props.onConnectGoogle))
    unavailable = <s-text color="subdued">{copy.backendUnavailable}</s-text>
  let googleUnavailable = null
  if (search && !soon && props.googleSetupUnavailable)
    googleUnavailable = <s-text color="subdued">{copy.googleSetupUnavailable}</s-text>
  return (
    <s-section heading={props.provider.label}>
      <s-stack gap="base">
        <s-badge tone={tone}>{label}</s-badge>
        <s-text color="subdued">{copy.providerDescriptions[props.provider.id] ?? props.provider.description}</s-text>
        {props.sources.map((source) => {
          let details = null
          if (props.onDetails) details = <s-button onClick={() => props.onDetails?.(source)}>{copy.details}</s-button>
          return (
            <s-stack key={source.relationshipId} direction="inline" gap="base">
              <s-text>
                {source.projectName}: {source.property}
              </s-text>
              {details}
            </s-stack>
          )
        })}
        {actions}
        {vote}
        {unavailable}
        {googleUnavailable}
      </s-stack>
    </s-section>
  )
}
